import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "btp-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"]
})
export class NavbarComponent implements OnInit {
  @Input() slotLeft = null;
  @Input() slotCenter = null;
  @Input() slotRight = null;
  constructor() {}

  ngOnInit() {}
}
